import { IPartnerAppSettings } from '../interface/IPartnerAppSettings';

export const sit: IPartnerAppSettings = {
  cdnBaseUrl: '',
  serviceEndPoints: [
    {
      clientId: 'c8955af6-b4a7-4e96-86b7-ad0930c25fa7',
      serviceEndPoint: 'https://dmsitafd.azurefd.net/'
    },
    {
      clientId: '99b7fa0a-a125-4f7a-abea-efb429bb8972',
      serviceEndPoint: 'https://oneprofileuatapipack.azurefd.net/api/v1/'
    },
    {
      clientId: '99b7fa0a-a125-4f7a-abea-efb429bb8972',
      serviceEndPoint: 'https://oneprofileuatapipack.azurefd.net/api/v2.0/'
    },
    {
      clientId: 'c1df0735-5f8f-4429-9977-80e732362bdd',
      serviceEndPoint: 'https://fd-rmxcsvc-sit-dch6dacwbedegta6.b02.azurefd.net/'
    },
    {
      clientId: '00000003-0000-0000-c000-000000000000',
      serviceEndPoint: 'https://graph.microsoft.com/'
    },
    {
      clientId: 'f77695f8-032a-43b9-9263-418c7efa2c56',
      serviceEndPoint: 'https://professionalservicesint.microsoft.com/csp-api/'
    },
    {
      clientId: 'c5779b49-c238-45cb-8974-36958d4c7d96',
      serviceEndPoint: 'https://cspa-dev-g5gkgngchpawf3a4.westus-01.azurewebsites.net/'
    },
    {
      clientId: 'c5779b49-c238-45cb-8974-36958d4c7d96',
      serviceEndPoint: 'http://localhost:4000/'
    }
  ],
  ReactDmAppConfiguration: {
    cspSubscriptionKey: '92af6c717f5b4f2c9a41db17e17cc947',
    dmServiceBaseUri: 'https://dmsitafd.azurefd.net/',
    cspBaseUrl: 'https://professionalservicesint.microsoft.com/csp-api/',
    oneProfileBaseUrl: 'https://oneprofileuatapipack.azurefd.net/',
    oneProfileGraphQlBaseUrl: 'https://preprod.apis.profileskills.microsoft.com/',
    oneProfileGraphQLPageSize: 1000,
    esxpBaseUrl: 'https://servicesint.azurewebsites.net/#/',
    rmexBaseUrl: 'https://fd-rmxcsvc-sit-dch6dacwbedegta6.b02.azurefd.net/',
    msxOpportunityUrl: 'https://msxuat.crm.dynamics.com/main.aspx?etn=opportunity&pagetype=entityrecord&id=%s',
    roleIds: '28,161,165,193',
    graphBaseApi: 'https://graph.microsoft.com/v1.0/',
    cspaBaseUrl: 'https://cspa-dev-g5gkgngchpawf3a4.westus-01.azurewebsites.net',
    rmexProgramsBaseUrl: 'https://fd-rmxcsvc-sit-dch6dacwbedegta6.b02.azurefd.net',
    deliveryBaseUrl: 'https://dmsitafd.azurefd.net/',
    esxpUrl: 'servicesint.azurewebsites.net'
  }
};
